import {
  STARTAPI_REQUEST_UNSEAL_TEC,
  SENDAPI_REQUEST_UNSEAL_TEC,
} from './constants'

export const startApiRequestUnsealTec = (message = '') => ({
  type: STARTAPI_REQUEST_UNSEAL_TEC,
  message,
})

export const sendApiRequestUnsealTec = (message = '') => ({
  type: SENDAPI_REQUEST_UNSEAL_TEC,
  message,
})
